import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
const EquipmentTransaction = () => {
  return <Grid>Transaction</Grid>;
};

export default EquipmentTransaction;
